import { Theme } from "../../../../components/constants";

export default {
    mainContainer: { 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '30px', 
        padding: '10px 70px'
    },
    userInfoRow: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: '20px'
    },
    text: { 
        fontSize: "16px",
        color: Theme.TEXT_PRIMARY_BLACK, 
        whiteSpace: 'pre'
    },
    buttonsRow: {
        display:'flex', 
        alignItems: 'center', 
        justifyContent: 'flex-end', 
        gap: '20px'
    },
}